module.exports = __webpack_public_path__ + "img/teppanku.9e12df16.png";